import React, { useEffect } from 'react';
import { useStore } from '../../../../../../store';
import { UserMessage } from '../../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { BILL_DETAILS_STYLES } from './styles';
import BillPreviewHeader from './components/BillPreviewHeader';
import BillPreviewContent from './components/BillPreviewContent';
import BillsPreviewAttachment from './components/BillPreviewAttachmentWrapper';
import { trackMixPanel } from '../../../../../../services/mixpanel.service';
import { BILLS_STATUSES } from '../../../../consts';
import { useClearQueryString } from '../../../../../../hooks/utilities/useClearQueryString';
import { CloseButton } from '../../../../../../DesignSystem/LiliCloseButton/CloseButton';

export const BillPreview = () => {
  const showBillDetailsModal = useStore((state) => state.showBillDetailsModal);
  const setShowBillDetailsModal = useStore((state) => state.setShowBillDetailsModal);
  const selectedBill = useStore((state) => state.selectedBill);
  const routerHistory = useStore((state) => state.routerHistory);
  const { clearQueryString } = useClearQueryString();

  useEffect(() => {
    if (showBillDetailsModal && selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING) {
      trackMixPanel('View on specific bill preview - pending', { Origin: routerHistory[routerHistory.length - 1] });
    }
    if (showBillDetailsModal && selectedBill?.calculatedStatus === BILLS_STATUSES.AWAITING_DETAILS) {
      trackMixPanel('View on specific bill preview - awaiting details', { Origin: routerHistory[routerHistory.length - 1] });
    }
    if (showBillDetailsModal && selectedBill?.calculatedStatus === BILLS_STATUSES.PAID) {
      trackMixPanel('View specific bill preview - paid', { Origin: routerHistory[routerHistory.length - 1] });
    }
  }, [showBillDetailsModal]);

  useEffect(
    () => () => {
      setShowBillDetailsModal(false);
    },
    [],
  );
  const onClose = () => {
    if (selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING) {
      trackMixPanel('Act on specific bill preview - pending', { Action: 'back' });
    }
    if (selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING) {
      trackMixPanel('Act on specific bill preview - awaiting details', { Action: 'back' });
    }
    if (selectedBill?.calculatedStatus === BILLS_STATUSES.PAID) {
      trackMixPanel('Act on specific bill preview - paid', { Action: 'back' });
    }
    setShowBillDetailsModal(false);
    clearQueryString();
  };

  if (!showBillDetailsModal || !selectedBill) return null;
  return (
    <UserMessage
      id='bill-details-modal'
      mainWrapperOverrideClassName={BILL_DETAILS_STYLES.MAIN.main}
      contentWrapperOverrideClassName={BILL_DETAILS_STYLES.MAIN.content}
      onClick={onClose}
    >
      <CloseButton onClick={onClose} id='close-button' className={`${BILL_DETAILS_STYLES.MAIN.exit}`} />

      <div className='block h-full bg-bw00'>
        <BillPreviewHeader title={`Bill #${selectedBill?.billNumber}`} />
        <BillPreviewContent billItem={selectedBill} />
        <BillsPreviewAttachment />
      </div>
    </UserMessage>
  );
};
